(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["checkout"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracle-cart-summary')) {
    customElements.define('oracle-cart-summary', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.header = this.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.mobileOpen = this.details.open;
        this.onLayout = () => {
          this.details.open = this.desktop.matches || this.mobileOpen;
        };
        this.onToggle = () => {
          if (this.desktop.matches) {
            if (!this.details.open) this.details.open = true;
          } else {
            this.mobileOpen = this.details.open;
          }
        };
        this.onHeaderClick = (event) => {
          if (this.desktop.matches) event.preventDefault();
        };
        this.desktop.addEventListener('change', this.onLayout);
        this.details.addEventListener('toggle', this.onToggle);
        this.header.addEventListener('click', this.onHeaderClick);
        this.onLayout();

        this.events = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.events.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.onLayout);
        this.details.removeEventListener('toggle', this.onToggle);
        this.header.removeEventListener('click', this.onHeaderClick);
        this.events.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Section request failed');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section unavailable');
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const nextBody = next?.querySelector('.ocs-summary-body');
          const nextTotal = next?.querySelector('.ocs-header-total');
          if (!nextBody || !nextTotal) throw new Error('Summary incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;
          // Remplacer uniquement le résumé : ne jamais recharger le paiement Whop.
          const body = this.querySelector('.ocs-summary-body');
          const total = this.querySelector('.ocs-header-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.header).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Checkout summary] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coaverif"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (!window.customElements || customElements.get('coa-verif')) return;

  const pdfBase = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@6.3.289/';
  let libraryPromise;
  const scrollLocks = new Set();
  let savedOverflow = '';

  function loadLibrary() {
    if (!libraryPromise) {
      libraryPromise = (async () => {
        let timer;
        try {
          const pdfjs = await Promise.race([
            import(pdfBase + 'legacy/build/pdf.mjs'),
            new Promise((_, reject) => {
              timer = setTimeout(() => reject(new Error('PDF library timeout')), 30000);
            })
          ]);
          pdfjs.GlobalWorkerOptions.workerSrc = pdfBase + 'legacy/build/pdf.worker.mjs';
          return pdfjs;
        } finally {
          clearTimeout(timer);
        }
      })().catch(error => {
        libraryPromise = null;
        throw error;
      });
    }
    return libraryPromise;
  }

  class CoaVerif extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (!this.isConnected || this.events) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const get = name => this.querySelector('[data-coa-' + name + ']');
      this.viewer = get('viewer');
      this.canvas = get('canvas');
      this.status = get('status');
      this.toolbar = get('toolbar');
      this.dialogTitle = get('dialog-title');
      this.original = get('original');
      this.retry = get('retry');
      this.previous = get('prev');
      this.next = get('next');
      this.count = get('count');
      this.zoomOut = get('zoom-out');
      this.zoomIn = get('zoom-in');
      this.zoomLabel = get('zoom');
      const on = (element, type, handler) => element.addEventListener(type, handler, { signal: this.events.signal });

      this.querySelectorAll('[data-coa-open]').forEach(link => {
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', this.dialog.id);
      });
      on(this, 'click', event => {
        const link = event.target.closest('[data-coa-open]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        try {
          const url = new URL(link.href, window.location.href);
          if (!['https:', 'http:'].includes(url.protocol)) return;
          this.dialog.showModal();
          event.preventDefault();
          this.trigger = link;
          this.original.href = url.href;
          this.dialogTitle.textContent = link.dataset.coaTitle;
          this.lockScroll();
          this.loadDocument(url.href);
        } catch (error) {
          // The original link still works if the browser cannot open the dialog.
        }
      });
      on(get('close'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        this.disposeDocument();
        this.unlockScroll();
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      });
      on(this.dialog, 'pointerdown', event => { this.backdropDown = event.target === this.dialog; });
      on(this.dialog, 'click', event => {
        if (this.backdropDown && event.target === this.dialog) this.dialog.close();
        this.backdropDown = false;
      });
      on(this.previous, 'click', () => this.changePage(-1));
      on(this.next, 'click', () => this.changePage(1));
      on(this.zoomOut, 'click', () => this.changeZoom(-0.25));
      on(this.zoomIn, 'click', () => this.changeZoom(0.25));
      on(this.retry, 'click', () => {
        if (this.dialog.open) this.loadDocument(this.original.href);
      });
      on(window, 'resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (this.session?.pdf) this.renderPage(this.session);
        }, 150);
      });
    }

    lockScroll() {
      if (!scrollLocks.size) {
        savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }
      scrollLocks.add(this);
    }

    unlockScroll() {
      if (scrollLocks.delete(this) && !scrollLocks.size) document.documentElement.style.overflow = savedOverflow;
    }

    isActive(session) {
      return this.isConnected && this.dialog.open && this.session === session && !session.cancelled;
    }

    showStatus(message, error = false) {
      this.status.textContent = message;
      this.status.hidden = false;
      this.retry.hidden = !error;
    }

    disposeDocument() {
      const session = this.session;
      this.session = null;
      if (!session) return;
      session.cancelled = true;
      clearTimeout(session.timer);
      session.renderTask?.cancel();
      // Removing a section in the editor also releases its PDF and worker.
      if (session.task) session.task.destroy().catch(() => {});
      this.canvas.hidden = true;
      this.canvas.width = 0;
      this.canvas.height = 0;
      this.viewer.removeAttribute('aria-busy');
    }

    async loadDocument(url) {
      this.disposeDocument();
      const session = { cancelled: false, page: 1, zoom: 1, renderVersion: 0 };
      this.session = session;
      this.toolbar.hidden = true;
      this.canvas.hidden = true;
      this.viewer.scrollTo(0, 0);
      this.viewer.setAttribute('aria-busy', 'true');
      this.showStatus('Loading PDF…');
      try {
        const pdfjs = await loadLibrary();
        if (!this.isActive(session)) return;
        session.task = pdfjs.getDocument({
          url,
          isEvalSupported: false,
          cMapUrl: pdfBase + 'cmaps/',
          cMapPacked: true,
          standardFontDataUrl: pdfBase + 'standard_fonts/',
          wasmUrl: pdfBase + 'wasm/'
        });
        session.pdf = await Promise.race([
          session.task.promise,
          new Promise((_, reject) => {
            session.timer = setTimeout(() => reject(new Error('PDF loading timeout')), 30000);
          })
        ]);
        clearTimeout(session.timer);
        if (!this.isActive(session)) return;
        this.toolbar.hidden = false;
        await this.renderPage(session);
      } catch (error) {
        if (!this.isActive(session)) return;
        this.disposeDocument();
        this.toolbar.hidden = true;
        this.showStatus('Preview unavailable. Try again or open the original PDF using the link below.', true);
      }
    }

    updateControls(session) {
      this.count.textContent = 'Page ' + session.page + ' / ' + session.pdf.numPages;
      this.previous.disabled = session.page <= 1;
      this.next.disabled = session.page >= session.pdf.numPages;
      this.zoomOut.disabled = session.zoom <= 0.75;
      this.zoomIn.disabled = session.zoom >= 2;
      this.zoomLabel.textContent = Math.round(session.zoom * 100) + ' %';
    }

    changePage(direction) {
      const session = this.session;
      if (!session?.pdf) return;
      const page = Math.max(1, Math.min(session.pdf.numPages, session.page + direction));
      if (page === session.page) return;
      session.page = page;
      this.viewer.scrollTo(0, 0);
      this.renderPage(session);
    }

    changeZoom(change) {
      const session = this.session;
      if (!session?.pdf) return;
      session.zoom = Math.max(0.75, Math.min(2, session.zoom + change));
      this.renderPage(session);
    }

    async renderPage(session) {
      const version = ++session.renderVersion;
      const current = () => this.isActive(session) && session.renderVersion === version;
      const pageNumber = session.page;
      this.updateControls(session);
      this.viewer.setAttribute('aria-busy', 'true');
      this.showStatus('Loading page ' + pageNumber + '…');
      this.canvas.hidden = true;
      const previousRender = session.renderTask;
      previousRender?.cancel();
      try {
        if (previousRender) await previousRender.promise.catch(() => {});
        if (!current()) return;
        const page = await session.pdf.getPage(pageNumber);
        if (!current()) return;
        const original = page.getViewport({ scale: 1 });
        const viewerStyle = getComputedStyle(this.viewer);
        const available = this.viewer.clientWidth - parseFloat(viewerStyle.paddingLeft) - parseFloat(viewerStyle.paddingRight) - 2;
        const width = Math.max(100, Math.min(900, available)) * session.zoom;
        const viewport = page.getViewport({ scale: width / original.width });
        // Limit memory use, including very tall pages and high-density mobile screens.
        const density = Math.min(window.devicePixelRatio || 1, 2, 4096 / Math.max(viewport.width, viewport.height));
        // Render offscreen so a previous document cannot overwrite the current page.
        const buffer = document.createElement('canvas');
        buffer.width = Math.max(1, Math.ceil(viewport.width * density));
        buffer.height = Math.max(1, Math.ceil(viewport.height * density));
        session.renderTask = page.render({
          canvasContext: buffer.getContext('2d'),
          viewport,
          transform: [density, 0, 0, density, 0, 0]
        });
        await session.renderTask.promise;
        if (!current()) return;
        this.canvas.width = buffer.width;
        this.canvas.height = buffer.height;
        this.canvas.style.width = Math.round(viewport.width) + 'px';
        this.canvas.style.height = Math.round(viewport.height) + 'px';
        this.canvas.getContext('2d').drawImage(buffer, 0, 0);
        this.canvas.setAttribute('aria-label', this.dialogTitle.textContent + ', page ' + pageNumber + ' of ' + session.pdf.numPages + '. To access the text, open the original PDF.');
        buffer.width = 0;
        buffer.height = 0;
        this.canvas.hidden = false;
        this.status.hidden = true;
      } catch (error) {
        if (current()) this.showStatus('This page could not be displayed. Try again or open the original PDF.', true);
      } finally {
        if (current()) this.viewer.removeAttribute('aria-busy');
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      clearTimeout(this.resizeTimer);
      this.events?.abort();
      this.events = null;
      if (this.dialog?.open) this.dialog.close();
      this.disposeDocument();
      this.unlockScroll();
    }
  }

  customElements.define('coa-verif', CoaVerif);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-research-gate-v09')) {
    class CartResearchGate extends HTMLElement {
      constructor() {
        super();

        this.updateButton = this.updateButton.bind(this);
        this.observer = new MutationObserver(this.updateButton);
        this.submitting = false;
        this.connectionVersion = 0;
      }

      connectedCallback() {
        this.connectionVersion++;
        this.events?.abort();
        this.events = new AbortController();
        const signal = this.events.signal;
        this.addEventListener('input', this.updateButton, { signal });
        this.addEventListener('change', this.updateButton, { signal });
        window.addEventListener('pageshow', () => {
          this.showMessage('');
          this.updateButton();
        }, { signal });
        window.addEventListener('click', (event) => {
          const button = event.target?.closest?.('.cart-research__submit');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          void this.continueToPayment();
        }, { capture: true, signal });

        this.observer.observe(this, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: [
            'value',
            'checked',
            'selected',
            'disabled',
            'required'
          ]
        });

        queueMicrotask(this.updateButton);
      }

      disconnectedCallback() {
        this.connectionVersion++;
        this.events?.abort();
        this.observer.disconnect();
      }

      requiredFields() {
        return Array.from(this.querySelectorAll('input[required], select[required]'));
      }

      selectedAttributes() {
        const fields = this.requiredFields();
        const names = [
          'Field of research',
          'Laboratory research use only acknowledged',
          'Terms and Conditions accepted'
        ];
        if (fields.length !== names.length) return null;
        const attributes = {};
        for (const name of names) {
          const field = fields.find((item) => item.name === 'attributes[' + name + ']');
          if (!field || field.disabled || !field.validity.valid ||
              (field.type === 'checkbox' ? !field.checked : !field.value.trim())) return null;
          attributes[name] = field.value;
        }
        return attributes;
      }

      showMessage(message) {
        const element = this.querySelector('[data-cart-research-message]');
        if (!element) return;
        element.textContent = message;
        element.hidden = !message;
      }

      updateButton() {
        const button = this.querySelector('.cart-research__submit');
        if (!button) return;
        const disabled = this.submitting || !this.selectedAttributes();
        if (button.disabled !== disabled) button.disabled = disabled;
        this.setAttribute('aria-busy', String(this.submitting));
        const label = button.querySelector('[data-cart-research-label]');
        if (label) {
          const text = this.submitting ? 'Saving your cart…' : 'Continue to secure checkout';
          if (label.textContent !== text) label.textContent = text;
        }
      }

      rememberPaymentAccess(cart) {
        if (typeof cart.token !== 'string' || !cart.token || !Array.isArray(cart.items) || !cart.items.length) {
          throw new Error('Your cart could not be confirmed. Please refresh this page and try again.');
        }
        // Keep the existing theme payment guard in sync with the confirmed cart.
        // Its signature includes the former email attribute, now empty.
        const attributeNames = [
          'Work or institution email',
          'Field of research',
          'Laboratory research use only acknowledged',
          'Terms and Conditions accepted'
        ];
        const signature = JSON.stringify([
          cart.token,
          cart.currency,
          cart.total_price,
          cart.items
            .map(item => [item.key, item.quantity, item.final_line_price])
            .sort((a, b) => a[0].localeCompare(b[0])),
          attributeNames.map(name => cart.attributes?.[name] || '')
        ]);
        try {
          sessionStorage.setItem('orabiolabs.payment-access.v1', signature);
        } catch (error) {
          throw new Error('Your browser could not save checkout access. Allow site storage and try again.');
        }
      }

      async continueToPayment() {
        if (this.submitting || !this.isConnected) return;
        const attributes = this.selectedAttributes();
        if (!attributes) {
          this.showMessage('Select your field of research and tick both required boxes.');
          this.requiredFields().find((field) => !field.validity.valid)?.reportValidity();
          this.updateButton();
          return;
        }
        this.submitting = true;
        const version = this.connectionVersion;
        this.showMessage('');
        this.updateButton();
        try {
          const updateUrl = new URL(this.dataset.cartUpdateUrl, window.location.href);
          const paymentUrl = new URL(this.dataset.paymentUrl, window.location.href);
          if (updateUrl.origin !== window.location.origin || paymentUrl.origin !== window.location.origin) {
            throw new Error('The checkout link is unavailable. Please refresh this page.');
          }
          // The update only writes attributes. Keep it independent of DOM lifecycle
          // cancellation so a section refresh cannot cancel an in-flight save.
          const response = await fetch(updateUrl.href, {
            method: 'POST', credentials: 'same-origin', cache: 'no-store',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { ...attributes, 'Work or institution email': '' } }),
            signal: AbortSignal.timeout(15000)
          });
          const cart = await response.json().catch(() => null);
          if (!response.ok || !cart) throw new Error('Your cart could not be saved. Please try again.');
          if (!Number.isSafeInteger(cart.item_count) || cart.item_count < 1) {
            throw new Error('Your cart is empty. Add a product before continuing.');
          }
          if (!Object.entries(attributes).every(([name, value]) => cart.attributes?.[name] === value) ||
              cart.attributes?.['Work or institution email']) {
            throw new Error('Your research information could not be saved. Please try again.');
          }
          if (!this.isConnected || this.connectionVersion !== version) return;
          const current = this.selectedAttributes();
          if (!current || !Object.entries(attributes).every(([name, value]) => current[name] === value)) {
            throw new Error('Your research information changed. Please continue again to save it.');
          }
          this.rememberPaymentAccess(cart);
          window.location.assign(paymentUrl.href);
        } catch (error) {
          if (this.isConnected && this.connectionVersion === version) {
            this.showMessage(error instanceof TypeError || error.name === 'TimeoutError' || error.name === 'AbortError'
              ? 'Your cart could not be saved. Check your connection and try again.'
              : error.message || 'Your cart could not be saved. Please try again.');
          }
        } finally {
          this.submitting = false;
          if (this.isConnected) this.updateButton();
        }
      }
    }

    customElements.define('cart-research-gate-v09', CartResearchGate);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onepage-checkout"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('orabio-onepage-v09')) return;
  const api = 'https://orabio-checkout-bridg-production.up.railway.app';
  // Keep the existing key so earlier or uncertain payments remain resumable.
  const key = 'orabio.checkout.v4';
  const uuid = value => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(value);
  const tokenOK = value => typeof value === 'string' && /^[0-9a-f]{64}$/.test(value);
  const hash = async value => Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)))).map(v => v.toString(16).padStart(2, '0')).join('');
  const shape = c => JSON.stringify([c.currency, c.total_price, c.attributes, c.items.map(i => [i.key, i.quantity, i.final_line_price]).sort((a, b) => String(a[0]).localeCompare(String(b[0])))]);
  const validationErrors = new Set(['INVALID_REQUEST', 'USD_ONLY', 'INVALID_CART', 'UNKNOWN_PRODUCT', 'UNSUPPORTED_CART', 'INVALID_EMAIL', 'CONSENT_REQUIRED', 'INVALID_DISCOUNT', 'US_ONLY', 'INVALID_ADDRESS']);

  customElements.define('orabio-onepage-v09', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true; this.stopped = false; this.initializing = true;
      this.status = this.querySelector('[data-one-status]');
      this.mount = this.querySelector('[data-one-mount]');
      this.events = new AbortController();
      if (this.dataset.designMode === 'true') {
        this.status.textContent = 'The Whop address and payment form appears here when you open checkout from the storefront cart.';
        this.initializing = false; return;
      }
      window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); }, { signal: this.events.signal });
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden && !this.stopped && !this.initializing) this.pollStatus();
      }, { signal: this.events.signal });
      this.loading(true); this.start();
    }
    disconnectedCallback() {
      this.stopped = true; this.events?.abort();
      clearTimeout(this.poll); clearTimeout(this.loadTimer);
      this.mount?.replaceChildren(); this.started = false;
    }
    loading(active) {
      this.querySelector('[data-one-loader]').hidden = !active;
      this.setAttribute('aria-busy', String(active));
    }
    stop(message) {
      this.loading(false); this.stopped = true;
      clearTimeout(this.poll); clearTimeout(this.loadTimer);
      this.mount.replaceChildren(); this.status.textContent = message;
    }
    errorMessage(error) {
      if (error.code === 'SESSION_NOT_FOUND') {
        return 'This checkout could not be resumed. Please contact the store with reference ' + this.session.id.slice(0, 8) + ' so we can check the previous payment.';
      }
      if (['SecurityError', 'QuotaExceededError'].includes(error.name)) return 'Allow browser storage to continue to payment.';
      return error.message || 'Checkout is temporarily unavailable. Refresh this page to resume.';
    }
    confirm() {
      this.stopped = true; clearTimeout(this.poll);
      location.assign('/pages/confirmation#orabio=' + this.session.id + '&token=' + this.session.token);
    }
    persist() { sessionStorage.setItem(key, JSON.stringify(this.session)); }
    async cart() {
      const response = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000) });
      if (!response.ok) throw new Error('Your cart could not be loaded. Refresh this page.');
      const cart = await response.json();
      if (!cart.items?.length) throw new Error('Your cart is empty. Return to your cart to add products.');
      return cart;
    }
    async checkCart() {
      if (await hash(shape(await this.cart())) !== this.session.cartHash) {
        this.clearEmbed(); this.stopped = true; location.reload(); return false;
      }
      return true;
    }
    async request(path, extra = {}) {
      const response = await fetch(api + path, {
        method: 'POST', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...extra, id: this.session.id, token: this.session.token }), signal: AbortSignal.timeout(20000)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        const error = new Error(data.message || 'Checkout is temporarily unavailable. Refresh this page to resume.');
        error.code = data.error; error.httpStatus = response.status; throw error;
      }
      if (data.id !== this.session.id) throw new Error('The checkout reference could not be verified.');
      return data;
    }
    async register(fresh) {
      // Persist intent before sending. A lost response must keep the same identity.
      this.session.registration = 'pending'; this.persist();
      try {
        await this.request('/api/checkout/native', this.payload);
      } catch (error) {
        // Only a fresh UUID's first explicit validation refusal proves this
        // request was rejected before insertion. An old/uncertain 404 never does.
        if (fresh && [400, 422].includes(error.httpStatus) && validationErrors.has(error.code)) {
          this.session.registration = 'not-created'; this.persist();
        }
        throw error;
      }
      this.session.registration = 'registered'; this.persist();
    }
    async resume() {
      // Read/authenticate before deciding whether to replace. Do not resubmit an
      // older request using the newly email-free payload or recreate a lost row.
      const state = await this.request('/api/checkout/status');
      this.session.registration = 'registered'; this.persist();
      if (state.paid || state.state === 'complete') { this.confirm(); return false; }
      return true;
    }
    async start() {
      this.initializing = true;
      try {
        const cart = await this.cart(), attributes = cart.attributes || {};
        const cartHash = await hash(shape(cart));
        if (cart.currency !== 'USD') throw new Error('Please use USD for this checkout.');
        if (cart.items.some(i => i.selling_plan_allocation || i.has_components || i.item_components?.length || Object.values(i.properties || {}).some(Boolean))) {
          throw new Error('This cart needs to be checked. Please contact the store.');
        }
        this.payload = {
          currency: cart.currency, expectedTotalMinor: cart.total_price,
          items: cart.items.map(i => ({ variantId: 'gid://shopify/ProductVariant/' + i.variant_id, quantity: i.quantity })),
          consent: {
            field: attributes['Field of research'],
            researchOnly: attributes['Laboratory research use only acknowledged'] === 'Yes',
            terms: attributes['Terms and Conditions accepted'] === 'Yes'
          },
          discountCodes: [...new Set([
            ...(cart.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code),
            ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title),
            ...cart.items.flatMap(i => (i.line_level_discount_allocations || []).filter(d => d.discount_application?.type === 'discount_code').map(d => d.discount_application.title))
          ])]
        };
        this.cartHash = cartHash; this.retryRetirement = true; this.needsReplacement = false;
        const stored = sessionStorage.getItem(key);
        let saved;
        try { saved = stored !== null ? JSON.parse(stored) : null; }
        catch { throw new Error('Your saved checkout reference could not be read. Please contact the store.'); }
        if (stored !== null && (!saved || typeof saved !== 'object' || Array.isArray(saved) || !uuid(saved.id) || !tokenOK(saved.token))) {
          throw new Error('Your saved checkout reference could not be verified. Please contact the store.');
        }
        if (saved && saved.complete !== true) {
          this.session = saved;
          this.needsReplacement = saved.cartHash !== cartHash || saved.flow !== 'native-shipping';
          if (saved.registration === 'not-created') {
            this.session.cartHash = cartHash; this.session.flow = 'native-shipping';
            this.needsReplacement = false;
            try { await this.register(false); }
            catch (error) {
              // Another tab may have accepted this identity in the meantime.
              if (error.code !== 'SESSION_CART_CHANGED') throw error;
              if (!await this.resume()) return;
              this.needsReplacement = true;
            }
          } else if (!await this.resume()) return;
        } else {
          this.session = {
            id: crypto.randomUUID(), token: Array.from(crypto.getRandomValues(new Uint8Array(32))).map(v => v.toString(16).padStart(2, '0')).join(''),
            cartHash, flow: 'native-shipping'
          };
          await this.register(true);
        }
        if (this.stopped || !this.isConnected) return;
        this.initializing = false;
        await this.pollStatus();
      } catch (error) { this.stop(this.errorMessage(error)); }
      finally { this.initializing = false; }
    }
    clearEmbed() {
      clearTimeout(this.loadTimer); this.mount.replaceChildren(); this.checkoutId = null;
      this.sdkReady = false; this.loading(true);
    }
    async pollStatus() {
      if (this.initializing || this.busy || this.stopped || !this.session) return;
      this.busy = true; clearTimeout(this.poll);
      try {
        const data = this.needsReplacement
          ? await this.request('/api/checkout/replace', { ...this.payload, cartHash: this.cartHash, retryRetirement: this.retryRetirement })
          : await this.request('/api/checkout/embed');
        if (this.needsReplacement) this.retryRetirement = false;
        if (this.stopped || !this.isConnected) return;
        this.data = data;
        if (data.paid || data.state === 'complete') { this.confirm(); return; }
        if (data.next) {
          if (!uuid(data.next.id) || !tokenOK(data.next.token) || !tokenOK(data.next.cartHash)) throw new Error('The checkout reference could not be verified.');
          sessionStorage.setItem(key, JSON.stringify({ ...data.next, registration: 'registered' }));
          this.stopped = true; location.reload(); return;
        }
        if (['review', 'rejected'].includes(data.state)) {
          this.stop('Checkout could not be updated. Please contact support with reference ' + data.reference + '.'); return;
        }
        if (this.needsReplacement || data.replacing || data.expired || data.state === 'superseded') {
          this.needsReplacement = true; this.clearEmbed();
          this.status.textContent = data.waitingPayment ? 'Your previous payment is being confirmed. Please wait…' : 'Updating your secure checkout…'; return;
        }
        if (data.embed) {
          if (!await this.checkCart() || this.stopped || !this.isConnected) return;
          if (!this.checkoutId) this.render(data);
          else if (this.checkoutId !== data.embed.checkoutId) throw new Error('Your checkout changed. Please refresh this page.');
        } else if (!this.checkoutId) this.status.textContent = 'Preparing your secure checkout…';
      } catch (error) {
        if (error.code === 'CHECKOUT_BUSY') this.status.textContent = 'Updating your secure checkout…';
        else this.stop(this.errorMessage(error));
      } finally {
        this.busy = false;
        if (!this.stopped) this.poll = setTimeout(() => this.pollStatus(), this.checkoutId ? 10000 : 1500);
      }
    }
    render(data) {
      const embed = data.embed, url = new URL(embed.returnUrl), fragment = new URLSearchParams(url.hash.slice(1));
      if (!/^plan_[A-Za-z0-9]+$/.test(embed.planId) || !/^ch_[A-Za-z0-9]+$/.test(embed.checkoutId) ||
          url.origin !== 'https://orabiolabs.com' || url.pathname !== '/pages/confirmation' ||
          fragment.get('orabio') !== this.session.id || !tokenOK(fragment.get('token')) ||
          !Number.isSafeInteger(data.totalMinor) || data.currency !== 'USD') throw new Error('The payment configuration could not be verified.');
      if (!embed.nativeShipping) throw new Error('This checkout uses the previous address form. Contact support before starting another payment.');
      this.checkoutId = embed.checkoutId;
      const element = document.createElement('div'); element.id = 'orabio-whop-' + this.session.id; this.embedElement = element;
      const attributes = {
        'plan-id': embed.planId, 'session': embed.checkoutId, 'return-url': embed.returnUrl,
        'theme': 'light', 'theme-accent-color': 'blue', 'hide-submit-button': 'false',
        'hide-address': 'false', 'hide-email': 'false', 'hide-price': 'true', 'skip-redirect': 'true',
        'prefill-email': embed.email, 'prefill-address-country': 'US', 'style-container-padding-x': '0',
        'style-container-padding-y': '0', 'skip-utm': 'true',
        'on-state-change': 'orabioOneState', 'on-complete': 'orabioOneComplete', 'on-payment-error': 'orabioOneError'
      };
      Object.entries(attributes).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') element.setAttribute('data-whop-checkout-' + key, value);
      });
      this.mount.replaceChildren(element);
      window.orabioOneState = state => {
        if (this.stopped) return;
        if (state === 'ready') { this.loading(false); this.sdkReady = true; clearTimeout(this.loadTimer); this.status.textContent = ''; }
      };
      window.orabioOneComplete = () => { if (!this.stopped) this.confirm(); };
      window.orabioOneError = () => {
        if (!this.stopped) { this.loading(false); this.status.textContent = 'Payment was not completed. Check the message in the Whop form before trying again.'; }
      };
      this.loadTimer = setTimeout(() => {
        if (!this.sdkReady && !this.stopped) { this.loading(false); this.status.textContent = 'Whop is taking longer to load. Refresh this page to resume the same checkout.'; }
      }, 20000);
      const loader = document.createElement('script'); loader.src = 'https://js.whop.com/static/checkout/loader.js'; loader.async = true; loader.defer = true;
      loader.onerror = () => this.stop('The Whop payment form could not load. Refresh this page to resume.'); document.head.append(loader);
    }
  });
})();


  if (!customElements.get('oracle-cart-summary')) {
    customElements.define('oracle-cart-summary', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.header = this.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.mobileOpen = this.details.open;
        this.onLayout = () => {
          this.details.open = this.desktop.matches || this.mobileOpen;
        };
        this.onToggle = () => {
          if (this.desktop.matches) {
            if (!this.details.open) this.details.open = true;
          } else {
            this.mobileOpen = this.details.open;
          }
        };
        this.onHeaderClick = (event) => {
          if (this.desktop.matches) event.preventDefault();
        };
        this.desktop.addEventListener('change', this.onLayout);
        this.details.addEventListener('toggle', this.onToggle);
        this.header.addEventListener('click', this.onHeaderClick);
        this.onLayout();

        this.events = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.events.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.onLayout);
        this.details.removeEventListener('toggle', this.onToggle);
        this.header.removeEventListener('click', this.onHeaderClick);
        this.events.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Section request failed');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section unavailable');
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const nextBody = next?.querySelector('.ocs-summary-body');
          const nextTotal = next?.querySelector('.ocs-header-total');
          if (!nextBody || !nextTotal) throw new Error('Summary incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;
          // Remplacer uniquement le résumé : ne jamais recharger le paiement Whop.
          const body = this.querySelector('.ocs-summary-body');
          const total = this.querySelector('.ocs-header-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.header).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Checkout summary] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paymentfinal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('oracle-cart-summary')) {
    customElements.define('oracle-cart-summary', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.header = this.querySelector('summary');
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.mobileOpen = this.details.open;
        this.onLayout = () => {
          this.details.open = this.desktop.matches || this.mobileOpen;
        };
        this.onToggle = () => {
          if (this.desktop.matches) {
            if (!this.details.open) this.details.open = true;
          } else {
            this.mobileOpen = this.details.open;
          }
        };
        this.onHeaderClick = (event) => {
          if (this.desktop.matches) event.preventDefault();
        };
        this.desktop.addEventListener('change', this.onLayout);
        this.details.addEventListener('toggle', this.onToggle);
        this.header.addEventListener('click', this.onHeaderClick);
        this.onLayout();

        this.events = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.events.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.onLayout);
        this.details.removeEventListener('toggle', this.onToggle);
        this.header.removeEventListener('click', this.onHeaderClick);
        this.events.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        this.unsubscribeCart?.();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) throw new Error('Section request failed');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section unavailable');
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(this.id);
          const nextBody = next?.querySelector('.ocs-summary-body');
          const nextTotal = next?.querySelector('.ocs-header-total');
          if (!nextBody || !nextTotal) throw new Error('Summary incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;
          // Remplacer uniquement le résumé : ne jamais recharger le paiement Whop.
          const body = this.querySelector('.ocs-summary-body');
          const total = this.querySelector('.ocs-header-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.header).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Checkout summary] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["summary1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('summary-one')) {
    customElements.define('summary-one', class extends HTMLElement {
      connectedCallback() {
        this.refreshEvents = ['summary1:refresh', 'cart:updated', 'cart:refresh', 'cart:change', 'product:added'];
        this.onRefresh = () => {
          // Cancel an older response immediately so it cannot overwrite newer cart data.
          this.request?.abort();
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.refresh(), 120);
        };
        this.onPageShow = (event) => { if (event.persisted) this.onRefresh(); };
        this.refreshEvents.forEach((name) => document.addEventListener(name, this.onRefresh));
        window.addEventListener('focus', this.onRefresh);
        window.addEventListener('pageshow', this.onPageShow);

        // Dawn publishes successful cart updates through its pub/sub helpers.
        this.connectDawn = () => {
          if (!this.unsubscribeCart && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onRefresh);
          }
        };
        this.connectDawn();
        if (document.readyState !== 'complete') window.addEventListener('load', this.connectDawn, { once: true });
      }

      disconnectedCallback() {
        this.refreshEvents.forEach((name) => document.removeEventListener(name, this.onRefresh));
        window.removeEventListener('focus', this.onRefresh);
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('load', this.connectDawn);
        if (this.unsubscribeCart) this.unsubscribeCart();
        this.unsubscribeCart = null;
        clearTimeout(this.refreshTimer);
        this.request?.abort();
      }

      async refresh() {
        if (!this.isConnected) return;
        this.request?.abort();
        const request = new AbortController();
        this.request = request;
        this.setAttribute('aria-busy', 'true');
        const timeout = setTimeout(() => request.abort(), 10000);

        try {
          // Preserve the current locale, template context, and theme preview query.
          const url = new URL(window.location.href);
          url.searchParams.delete('section_id');
          url.searchParams.set('sections', this.dataset.sectionId);
          url.hash = '';
          const response = await fetch(url.toString(), {
            signal: request.signal,
            credentials: 'same-origin',
            cache: 'no-store'
          });
          if (!response.ok) throw new Error('Section request failed: ' + response.status);
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (typeof html !== 'string') throw new Error('Section is unavailable');
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const next = parsed.getElementById(this.id);
          const nextBody = next?.querySelector('.s1-body');
          const nextTotal = next?.querySelector('.s1-total');
          if (!nextBody || !nextTotal) throw new Error('Section markup is incomplete');
          if (!this.isConnected || request.signal.aborted || this.request !== request) return;

          // Keep the summary element and its open state, keyboard focus, and live region.
          const body = this.querySelector('.s1-body');
          const total = this.querySelector('.s1-total');
          const activeLink = body.contains(document.activeElement) ? document.activeElement.closest('a') : null;
          const activeHref = activeLink?.getAttribute('href');
          if (body.innerHTML !== nextBody.innerHTML) {
            body.innerHTML = nextBody.innerHTML;
            if (activeLink) {
              const replacement = Array.from(body.querySelectorAll('a')).find((link) => link.getAttribute('href') === activeHref);
              (replacement || this.querySelector('.s1-header')).focus({ preventScroll: true });
            }
          }
          if (total.innerHTML !== nextTotal.innerHTML) total.innerHTML = nextTotal.innerHTML;
          this.removeAttribute('data-refresh-error');
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.setAttribute('data-refresh-error', 'true');
            console.warn('[Summary1] Cart refresh failed.', error);
          }
        } finally {
          clearTimeout(timeout);
          if (this.request === request) {
            this.removeAttribute('aria-busy');
            this.request = null;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
